// The schedule now lives in the trainings area, as its editions tab. This route
// stays only so bookmarks and old links still land in the right place.

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/scheduling")({
	beforeLoad: () => {
		throw redirect({ to: "/admin/trainings" });
	},
});
